'use strict';

angular.module('myConsultApp').factory('utilities', function ($resource, ENV, Session) {
  //-- Array: ensure .contains works for ie11

  if (!Array.prototype.contains) {
    Array.prototype.contains = function (obj) {
      var i = this.length;
      while (i--) {
        if (this[i] === obj) {
          return true;
        }
      }
      return false;
    };
  }

  //-- Array: ensure .includes works for ie11

  if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
      value: function (searchElement, fromIndex) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (len === 0) {
          return false;
        }
        var n = fromIndex | 0;
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        function sameValueZero(x, y) {
          return (
            x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
          );
        }
        while (k < len) {
          if (sameValueZero(o[k], searchElement)) {
            return true;
          }
          k++;
        }
        return false;
      },
    });
  }

  //-- Array find prototype function for IE support

  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function (predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }
        var thisArg = arguments[1];
        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          k++;
        }
        return undefined;
      },
      configurable: true,
      writable: true,
    });
  }

  //--- String startswith polyfill
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (search, pos) {
      return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
  }

  return {
    //-- function for contextual string replacement in various locations

    getText: function (pet, breed, text) {
      var newText = '';
      if (typeof text !== 'undefined') {
        var newText = text;
      }

      newText = newText.replace(/\{pet_name\}/g, pet.name);
      newText = newText.replace(/<pet_name>/g, pet.name);
      newText = newText.replace(/<Pet's Name>/g, pet.name);
      newText = newText.replace(/<Breed Name>/g, breed);

      var last = breed.substr(breed.length - 1, breed.length);

      if (last == 's' || last == 'x') {
        newText = newText.replace(/\{[b,B]reed\}s/g, breed + 'es');
      }

      newText = newText.replace(/\{[b,B]reed\}/g, breed);
      newText = newText.replace(/<[b,B]reed>/g, breed);
      newText = newText.replace(/\{br\}/g, '<br><br>');

      if (pet.is_male) {
        newText = newText.replace(/<his\/her>/g, 'his');
        newText = newText.replace(/<His\/her>/g, 'His');
        newText = newText.replace(/<his\/Her>/g, 'His');
        newText = newText.replace(/<His\/Her>/g, 'His');
        newText = newText.replace(/<him\/her>/g, 'him');
        newText = newText.replace(/<him\/Her>/g, 'Him');
        newText = newText.replace(/<Him\/her>/g, 'Him');
        newText = newText.replace(/<Him\/Her>/g, 'Him');
        newText = newText.replace(/<He\/She>/g, 'He');
        newText = newText.replace(/<He\/she>/g, 'He');
        newText = newText.replace(/<he\/she>/g, 'he');
        newText = newText.replace(/<He\/She>/g, 'He');
        newText = newText.replace(/<himself\/herself>/g, 'himself');
        newText = newText.replace(/<Himself\/Herself>/g, 'Himself');
        newText = newText.replace(/<Himself\/herself>/g, 'Himself');
        newText = newText.replace(/<himself\/Herself>/g, 'Himself');

        newText = newText.replace(/\{his\/her\}/g, 'his');
        newText = newText.replace(/\{His\/her\}/g, 'His');
        newText = newText.replace(/\{His\/Her\}/g, 'His');
        newText = newText.replace(/\{his\/Her\}/g, 'His');
        newText = newText.replace(/\{him\/her\}/g, 'him');
        newText = newText.replace(/\{Him\/her\}/g, 'Him');
        newText = newText.replace(/\{Him\/Her\}/g, 'Him');
        newText = newText.replace(/\{him\/Her\}/g, 'Him');
        newText = newText.replace(/\{He\/She\}/g, 'He');
        newText = newText.replace(/\{He\/she\}/g, 'He');
        newText = newText.replace(/\{he\/she\}/g, 'he');
        newText = newText.replace(/\{he\/She\}/g, 'He');
        newText = newText.replace(/\{himself\/herself\}/g, 'himself');
        newText = newText.replace(/\{Himself\/Herself\}/g, 'Himself');
        newText = newText.replace(/\{himself\/Herself\}/g, 'Himself');
        newText = newText.replace(/\{Himself\/herself\}/g, 'Himself');
      } else {
        newText = newText.replace(/<his\/her>/g, 'her');
        newText = newText.replace(/<His\/her>/g, 'Her');
        newText = newText.replace(/<his\/Her>/g, 'Her');
        newText = newText.replace(/<His\/Her>/g, 'Her');
        newText = newText.replace(/<him\/her>/g, 'her');
        newText = newText.replace(/<Him\/her>/g, 'Her');
        newText = newText.replace(/<Him\/Her>/g, 'Her');
        newText = newText.replace(/<him\/Her>/g, 'Her');
        newText = newText.replace(/<He\/She>/g, 'She');
        newText = newText.replace(/<He\/she>/g, 'She');
        newText = newText.replace(/<he\/she>/g, 'she');
        newText = newText.replace(/<he\/She>/g, 'She');
        newText = newText.replace(/<himself\/herself>/g, 'herself');
        newText = newText.replace(/<Himself\/Herself>/g, 'Herself');
        newText = newText.replace(/<Himself\/herself>/g, 'Herself');
        newText = newText.replace(/<himself\/Herself>/g, 'Herself');

        newText = newText.replace(/\{his\/her\}/g, 'her');
        newText = newText.replace(/\{His\/her\}/g, 'Her');
        newText = newText.replace(/\{His\/Her\}/g, 'Her');
        newText = newText.replace(/\{his\/Her\}/g, 'Her');
        newText = newText.replace(/\{him\/her\}/g, 'her');
        newText = newText.replace(/\{Him\/her\}/g, 'Her');
        newText = newText.replace(/\{Him\/Her\}/g, 'Her');
        newText = newText.replace(/\{him\/Her\}/g, 'Her');
        newText = newText.replace(/\{He\/She\}/g, 'She');
        newText = newText.replace(/\{He\/she\}/g, 'She');
        newText = newText.replace(/\{he\/she\}/g, 'she');
        newText = newText.replace(/\{he\/She\}/g, 'She');
        newText = newText.replace(/\{himself\/herself\}/g, 'herself');
        newText = newText.replace(/\{Himself\/Herself\}/g, 'Herself');
        newText = newText.replace(/\{Himself\/herself\}/g, 'Herself');
        newText = newText.replace(/\{himself\/Herself\}/g, 'Herself');
      }

      return newText;
    },

    cleanArray: function (arr) {
      arr = arr.filter(function (n) {
        return n != undefined;
      });
      return arr;
    },

    filterByMultipleKeyValues: function (srcArray, keyValues) {
      if (!srcArray) {
        return undefined;
      }
      if (!keyValues) {
        return [].concat(srcArray);
      }
      return srcArray.filter(function (current) {
        return Object.keys(keyValues).reduce(function (isMatch, key) {
          // if not is match then no need to check. Or if value for key doesn't exist don't check it.
          if (!isMatch || typeof keyValues[key] === 'undefined' || keyValues[key] === null) {
            return isMatch;
          }
          return current[key] === keyValues[key];
        }, true);
      });
    },

    getResourceUrl: function (url) {
      var user = $resource(
        url,
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return user.get().$promise.then(function (response) {
        return response;
      });
    },

    submitTelemetry: (obj) => {
      if (typeof window !== 'undefined' && window.dataLayer && typeof obj === 'object') {
        window.dataLayer.push(obj);
        return window.dataLayer;
      }
    },
  };
});
